// services
import { Http } from "@shared/svelte/Modules/ApiService";

// stores
import { dwollaAcknowledgmentsStore } from "@retailer/svelte/stores/DwollaAcknowledgmentsStore";

// types
import type { HTTPParams } from "@shared/types/HTTP";

const baseUrl = "/api/retailer/dwolla_acknowledgements";

const makeReq = async (requestData, successCB) => {
  const errCB = () => {
    dwollaAcknowledgmentsStore.update((dwollaAcknowledgmentsState) => ({
      ...dwollaAcknowledgmentsState,
      loaded: true,
      failed: true,
    }));
  };

  dwollaAcknowledgmentsStore.update((dwollaAcknowledgmentsState) => ({
    ...dwollaAcknowledgmentsState,
    loaded: false,
    failed: false,
  }));

  await Http(requestData, successCB, errCB)
}

export const get = async () => {
  const requestData: HTTPParams = {
    method: "GET",
    url: baseUrl
  };

  const successCB = (json) => {
    dwollaAcknowledgmentsStore.set({
      loaded: true,
      failed: false,
      dwollaAcknowledgments: json
    })
  };

  makeReq(requestData, successCB)
};

export const create = async () => {
  const requestData: HTTPParams = {
    method: "POST",
    url: baseUrl,
  };

  const successCB = () => {
    get();
  };

  makeReq(requestData, successCB)
};
